import {
    IExternalLinksHandlersFactory
} from "../../external-links/handlers-factory/external-links-handlers-factory.interface";
import {
    UkExternalLinksHandlersFactory
} from "../../external-links/handlers-factory/regulations/uk/uk.external-links-handlers-factory";
import { UKRegulationComponents } from "./components/uk.regulation-components";
import { IRegulationComponents } from "../regulation-components.interface";
import {IRealityCheckHandler} from "../../session-timer/reality-check/handlers/reality-check-handler.interface";
import {StandardRealityCheckHandler} from "../../session-timer/reality-check/handlers/standard-reality-check-handler";
import {UkRealityCheckPresenter} from "../../session-timer/reality-check/presenters/uk/uk.reality-check-presenter";
import {RegulationWithRealityCheck} from "../regulation-with-reality-check";

export class UkRegulation extends RegulationWithRealityCheck {
    get components(): IRegulationComponents {
        return new UKRegulationComponents(this.services);
    }
    
    get externalLinks(): IExternalLinksHandlersFactory {
        return new UkExternalLinksHandlersFactory(this.services);
    }

    get shouldShowExitGamePopup(): boolean {
        return false;
    }

    createRealityCheckHandler(): IRealityCheckHandler {
        return new StandardRealityCheckHandler(this.services, new UkRealityCheckPresenter(this.services));
    }
}